import { render, staticRenderFns } from "./cosmetregister.vue?vue&type=template&id=e609f05c&scoped=true&"
import script from "./cosmetregister.vue?vue&type=script&lang=ts&"
export * from "./cosmetregister.vue?vue&type=script&lang=ts&"
import style0 from "./cosmetregister.vue?vue&type=style&index=0&id=e609f05c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e609f05c",
  null
  
)

export default component.exports